import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiPhone, FiMessageCircle, FiUser } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function RecentActivitiesCard() {
  return (
    <Card className="ra-card w-100">
      <Card.Header className="ra-header card-header-custom">
        <h5>Recent Activities</h5>
     <Button
  as={Link}
  to="/activity"
  variant="light"
  size="sm"
  className="text-decoration-none"
>
  View All
</Button>
      </Card.Header>

      <Card.Body>
        <div className="ra-item">
          <div className="ra-icon green"><FiPhone /></div>
          <div>
            <p>Drain responded to your appointment schedule question.</p>
            <span>09:25 PM</span>
          </div>
        </div>

        <div className="ra-item">
          <div className="ra-icon blue"><FiMessageCircle /></div>
          <div>
            <p>You sent 1 Message to the James.</p>
            <span>10:25 PM</span>
          </div>
        </div>

        <div className="ra-item">
          <div className="ra-icon green"><FiPhone /></div>
          <div>
            <p>Denwar responded to your appointment on 25 Jan 2025</p>
            <span>09:25 PM</span>
          </div>
        </div>

        <div className="ra-item">
          <div className="ra-icon purple"><FiUser /></div>
          <div>
            <p>Meeting With Abraham</p>
            <span>09:25 PM</span>
          </div>
        </div>
      </Card.Body>

      <style>{`
        .ra-card {
          border: 2px solid #e5e7eb;
          border-radius: 5px;
        }


      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
        .ra-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .ra-btn {
          background: #f9fafb;
          border: 1px solid #e5e7eb;
        }
             .ra-btn:hover {
                border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;
        }


        .ra-item {
          display: flex;
          gap: 13px;
          margin-bottom: 20px;
        }

        .ra-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }

        .green { background: #22c55e; }
        .blue { background: #3b82f6; } /* only here minimal */
        .purple { background: #a855f7; }

        .ra-item p {
          margin: 0;
          font-size: 16px;
          font-weight: 500;
        }

        .ra-item span {
          font-size: 14px;
          color: #6b7280;
        }

        @media (max-width: 1024px) {
          .ra-card {
            margin-top: 15px;
          }
        }
      `}</style>
    </Card>
  );
}